import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Section, TextColumn, Automec, TextoAbaixo } from './../styles/styles';

import povao from './../styles/overview1.png';
import coisas from './../styles/overview2.png';
import poteMarca from './../styles/overview3.png'; 
import poteblender from './../styles/poteblender.png';
import poteresult from './../styles/poteresultado.png';
import evento2 from './../styles/evento2.png';
import evento3 from './../styles/evento3.png';
import evento4 from './../styles/evento4.png';
import evento5 from './../styles/evento5.png';
import evento6 from './../styles/evento6.png';

const conteudos = [
  {
    titulo: "Overview",
    desc: [
      {
        text: " Full visual development and spatial planning for the Sigma Tools booth at FEICON 2025, one of Latin America's largest construction trade shows. I was responsible for the end-to-end design strategy, ensuring the brand’s presence was high-impact, cohesive, and commercially optimized."
      },
      {
        title: "Role:",
        text: "Event Designer"
      },
      {
        title: "Responsibilities:",
        text: "3D Booth Modeling, Banner Design & Technical Pre-press, Product Photography, Motion Graphics Collaboration, and On-site Creative Support."
      }
    ],
    img: evento2
  },
  {
    titulo: "Challenge",
    desc: [
      {
        text: "The primary challenge was to create a stand that stood out in a saturated environment. We needed to organize a vast product catalog into a physical space that was both aesthetically striking and functional for the sales team, while ensuring all large-format graphics were technicality perfect for installation."
      }
    ],
    img: evento3
  },
  {
    titulo: "Solution",
    desc: [
      {
        title: "Technical Precision & Pre-press: :",
        text: "Meticulous management of die-lines  and technical dimensions for all large-format prints, ensuring perfect alignment and zero information loss during the cutting and installation process."
      },
      {
        title: "Strategic Branding: ",
        text: "Applied a bold typographic and color system (matching the brand's DNA) to ensure 360-degree visibility, including a high-impact overhead video display coordinated with the video team."
      },
      {
        title: "High-Volume Content Production:",
        text: "Executed professional photography for approximately 30 key products with advanced retouching, alongside 9 high-end 3D renders specifically for the booth's visual communication."
      }
    ],
    img: evento4
  },
  {
    titulo: "Solution",
    desc: [
      {
        title: "3D Booth Pre-visualization:",
        text: "Developed a full 3D model of the stand to align expectations with the commercial team and optimize the flow of visitors before construction began."
      },
      {
        title: "Large-Format Graphics:",
        text: "Designed and organized all event banners, creating a technical installation manual for the printing and assembly team to ensure zero errors on-site."
      },
      {
        title: "Digital Integration:",
        text: "Implemented strategic QR Code displays across the booth, bridging the gap between the physical experience and the digital product catalog for instant lead capture"
      },
      {
        title: "Product Showcase:",
        text: "Executed professional photography and high-end Photoshop retouching for all featured products to ensure premium quality in every visual touchpoint."
      }
    ],
    img: evento5
  },
  {
    titulo: "Results",
    desc: [
      {
        title: "Sales Growth: ",
        text: "The booth was a massive commercial success, contributing to a 30% increase in sales compared to previous events."
      },
      {
        title: "High Visibility:",
        text: "The stand became a benchmark at the event, recognized for its superior lighting, aggressive branding, and eye-catching design that outperformed competitors."
      },
      {
        title: "Operational Excellence:",
        text: "Delivered a flawless execution from digital renders to physical installation, providing the sales team with a high-performance environment."
      },
      {
        title: "Asset Management:",
        text: "Created a complete library of event photography and visual data used for post-event marketing and future B2B strategies."
      }
    ],
    img: evento6
  }
];

const ProjetoBrand = () => {
  const containerRef = useRef(null);
  const [dragWidth, setDragWidth] = useState(0);

  useEffect(() => {
    const calcularWidth = () => {
      if (!containerRef.current) return;

      const scrollWidth = containerRef.current.scrollWidth;
      const offsetWidth = containerRef.current.offsetWidth;

      setDragWidth(scrollWidth - offsetWidth);
    };

    calcularWidth();
    window.addEventListener('resize', calcularWidth);

    return () => window.removeEventListener('resize', calcularWidth);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        overflow: 'hidden',
        position: 'relative'
      }}
    >
      <motion.div
        drag="x"
        dragConstraints={{ left: -dragWidth, right: 0 }}
        dragElastic={0.1}
        dragMomentum={false}
        style={{
          display: 'flex',
          width: 'max-content',
          cursor: 'grab'
        }}
        whileTap={{ cursor: 'grabbing' }}
      >
        {conteudos.map((item, index) => (
          <Section
            key={index}
            style={{
              width: '1500',
              flexShrink: 0,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingLeft: '40px',
              boxSizing: 'border-box'
            }}
          >
             <img
              src={item.img}
              alt={item.titulo}
              draggable={false}
              style={{
                width: 'auto',
                height: '70vh',
                marginLeft: '200px',
                pointerEvents: 'none',
                userSelect: 'none',
                borderRadius: '20px'
              }}
            />
            <TextColumn>
              <Automec>{item.titulo}</Automec>

              <TextoAbaixo>
                {item.desc.map((bloco, i) => (
                  <p key={i}>
                    {bloco.title && <strong>{bloco.title}</strong>} {bloco.text}
                  </p>
                ))}
              </TextoAbaixo>
            </TextColumn>

           
          </Section>
        ))}
      </motion.div>
    </div>
  );
};

export default ProjetoBrand;